// The reference a product answers to in logic and report filters (A{a} / A{a}CS{c}); null for a row
// the numbering excludes, the flat position only for a legacy schema that ships no id at all.
export const productCode = av => {
  if (!Object.hasOwn(av, 'id')) return `A${av.position}`
  return av.id?.toUpperCase() || null
}

// Parent, then its variants in value order.
export const productsInDisplayOrder = (answerVariants = []) =>
  (answerVariants || [])
    .filter(av => null != av)
    .sort((a, b) => (a.displayOrder ?? a.position) - (b.displayOrder ?? b.position))

// A variant is a coded row that names a parent; an uncoded one is a row the numbering excludes,
// whatever parent it names.
const isVariant = av => null != productCode(av) && Boolean(av.parentProduct)
const isTopLevel = av => null != productCode(av) && !av.parentProduct

// Each product's place in its family, read off its neighbours in display order: 'parent',
// 'variant', 'last-variant', or null for a product without variants and an uncoded row. The CS
// number is no guide to which variant is last -- variants stand in the author's value order.
export const familyRolesOf = (products = []) => {
  const roles = products.map(() => null)

  products.forEach((av, index) => {
    if (0 === index || !isVariant(av)) return

    const prev = products[index - 1]
    if (isTopLevel(prev)) roles[index - 1] = 'parent'
    else if (!roles[index - 1]) return

    roles[index] = 'variant'
  })

  return roles.map((role, index) => ('variant' === role && 'variant' !== roles[index + 1] ? 'last-variant' : role))
}
